import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSummaryState } from '../store/selectors/getSummaryState';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import summaryReducer from '../store/reducers/summary';
import contentGraphDatasource from '@gameday/core/datasources/contentGraph';
import contentDatasource from '@gameday/core/datasources/content';
import playMetricsDataSource from '@gameday/core/datasources/playMetrics';
import summaryDataRequestAction from '../store/actions/summaryDataRequestAction';
import Summary from '../Summary.js';
import playReducer from '../../Play/store/reducers/play';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

const fetchData = () => {
    return summaryDataRequestAction();
};

initContainerData.register({
    datasources: {
        content: contentDatasource,
        contentGraph: contentGraphDatasource,
        playMetrics: playMetricsDataSource
    },
    reducers: {
        play: playReducer,
        summary: summaryReducer
    }
});
const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const SummaryDataContainer = (props) => {
    const {
        isFinal = false
    } = props;

    const summaryState = useSelector(getSummaryState(isFinal));

    return (
        <ErrorBoundaryWrapper componentName='Summary'>
            <Summary { ...summaryState } {...props}/>
        </ErrorBoundaryWrapper>
    );
};

export default SummaryDataContainer;
export { fetchData, routes };
